export enum MetaClassField {
  Fields = 'fields',
  IdField = 'idField',
  TypeField = 'typeField',
  MapParse = 'parse',
  MapSerialize = 'serialize',
  MapField = 'map',
}
